import css from './UsersEmail.module.scss'
import React from 'react'
import MediaQuery from 'react-responsive'
import { Outlet } from 'react-router-dom'
import classNames from 'classnames'

import { BalloonSize, BalloonTipPosition, ComponentColor } from 'meta/backendControlled/structure'
import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'

import withTranslation from 'components/HOC/WithTranslation'
import BalloonWrapper from 'components/Layout/BalloonWrapper'
import Video from 'components/Media/Video'

const usersEmail: React.FC = () => {
  const color = ComponentColor.black

  return (
    <div className={classNames(css.usersEmail, css[color])}>
      <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
        <Video url="/dj.mp4" />
      </MediaQuery>

      <MediaQuery maxWidth={BreakpointsMaxWidth.mobile}>
        <div className={css.usersEmail__content}>
          <Outlet />
        </div>
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
        <div className={css.usersEmail__balloonContainer}>
          <BalloonWrapper color={color} tipPosition={BalloonTipPosition.right} size={BalloonSize.small}>
            <div className={css.usersEmail__content}>
              <Outlet />
            </div>
          </BalloonWrapper>
        </div>
      </MediaQuery>
    </div>
  )
}

const namespaces = ['email_confirm']
export default withTranslation(namespaces)(usersEmail)
